<template>
  <section id="cta-final" class="section-shell final-section" data-theme="portal">
    <div class="final-card" data-reveal>
      <div class="lines">
        <p>Voc&ecirc; sabe que pode mais.</p>
        <p>Voc&ecirc; sabe que o jogo tem regras &mdash; e voc&ecirc; n&atilde;o as conhece.</p>
        <p>A diferen&ccedil;a entre quem ganha e quem perde n&atilde;o &eacute; sorte.</p>
        <p class="accent">&Eacute; leitura.</p>
        <p class="accent">&Eacute; timing.</p>
        <p class="accent">&Eacute; clareza.</p>
        <p>&Eacute; estar do lado certo do mercado &mdash; enquanto os outros reagem.</p>
        <p>A <span class="word-brand">ZIMA</span> te entrega isso.</p>
        <p>O mercado n&atilde;o tira folga. Abre todo dia, com ou sem voc&ecirc;.</p>
        <p>A pergunta n&atilde;o &eacute; se voc&ecirc; vai operar. &Eacute; se vai continuar reagindo &mdash; ou come&ccedil;ar a antecipar.</p>
        <p>Toda semana que voc&ecirc; fica de fora &eacute; uma semana lendo candle enquanto o dinheiro l&ecirc; fluxo.</p>
        <p>A <span class="word-brand">ZIMA</span> n&atilde;o &eacute; curso que voc&ecirc; compra uma vez e esquece. &Eacute; acesso cont&iacute;nuo &agrave; leitura que o varejo n&atilde;o tem.</p>
        <p class="accent">Come&ccedil;a por R$97/m&ecirc;s. Cancela quando quiser.</p>
        <p class="strong">Ou trava o ano por R$797 &mdash; menos de R$67 por m&ecirc;s, quase 4 meses no bolso.</p>
        <p>A decis&atilde;o &eacute; sua:</p>
        <p>Continuar reagindo &mdash; ou come&ccedil;ar a antecipar.</p>
        <p>Testar um m&ecirc;s &mdash; ou entrar de vez e parar de pensar nisso.</p>
      </div>

      <div class="cta-wrap">
        <p class="promo-badge">Acesso imediato</p>
        <button class="cta primary" @click="$emit('cta')">[ Come&ccedil;ar agora &mdash; R$97/m&ecirc;s ]</button>
        <p class="footnote">Semestral por R$447, ou R$353,88 no PIX. Anual por R$797, ou R$630,80 no PIX. Cancela quando quiser.</p>
      </div>
    </div>
  </section>
</template>

<script setup>
</script>

<style scoped>
.final-section {
  padding: 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  overflow: visible !important;
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;
}

.final-section,
.final-section * {
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;
}

.final-section::before {
  display: none !important;
}

.final-card {
  border-radius: 16px;
  border: 1px solid rgba(115, 148, 240, 0.22);
  background: linear-gradient(165deg, rgba(11, 14, 24, 0.9), rgba(8, 10, 18, 0.92));
  padding: 16px;
  position: relative;
  overflow: hidden;
  box-shadow:
    0 26px 72px rgba(0, 0, 0, 0.42),
    0 0 0 1px rgba(115, 148, 240, 0.1) inset;
}

.final-card::before {
  content: '';
  position: absolute;
  inset: 0 12px auto;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(78, 115, 223, 0), rgba(118, 150, 240, 0.84) 22%, rgba(166, 118, 228, 0.8) 78%, rgba(155, 89, 182, 0));
}

.lines {
  position: relative;
  z-index: 1;
  display: grid;
  gap: 4px;
}

.lines p {
  margin: 0;
  color: #d2dcf0;
  line-height: 1.42;
  font-size: clamp(1.04rem, 1.14vw, 1.2rem);
  font-style: italic;
}

.word-brand {
  background: linear-gradient(120deg, #6fa6ff 0%, #bd8bff 45%, #7ea5ff 75%, #d2b2ff 100%);
  background-size: 220% 220%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 0 14px rgba(127, 166, 255, 0.28);
  animation: zima-brand-shift 4.2s ease-in-out infinite;
  will-change: background-position;
}

.lines .accent {
  background: linear-gradient(135deg, #4e73df 0%, #9b59b6 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  text-shadow: 0 2px 12px rgba(78, 115, 223, 0.35);
  font-weight: 700;
}

.lines .strong {
  font-weight: 700;
}

.cta-wrap {
  margin-top: 12px;
  display: grid;
  gap: 6px;
  position: relative;
  z-index: 1;
}

.footnote {
  color: #aebdde;
  font-size: 0.86rem;
  font-style: italic;
}

.promo-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #c7f5e5;
  text-shadow: 0 0 14px rgba(56, 211, 159, 0.18);
}

.promo-badge::before {
  content: '';
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: radial-gradient(circle, #9df1cf 0%, #38d39f 62%, rgba(56, 211, 159, 0.15) 100%);
  box-shadow:
    0 0 0 3px rgba(56, 211, 159, 0.14),
    0 0 16px rgba(56, 211, 159, 0.45);
}

.cta.primary:hover {
  box-shadow:
    0 0 0 1px rgba(170, 191, 255, 0.52) inset,
    0 20px 50px rgba(10, 20, 40, 0.72),
    0 0 26px rgba(155, 89, 182, 0.35);
}

.cta.primary:active {
  transform: translateY(1px);
}

@keyframes zima-brand-shift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
